import React, { useCallback } from "react";
import { socket } from "../../../../lib/socketio";
import { Grid, Button, Segment } from "semantic-ui-react";
import OperationModePSM3 from "../../../Macros/OperationModePSM3";
import ConfirmMacro from "../../../Macros/ConfirmMacro";
import EventLog from "../EventLog";
import { GroupTemplate } from "../../../Definitions/cl";
import Footer from "../../Footer";
import _ from "lodash";
import PPOperationMacroPSM3 from "../../../Macros/PPOperationMacroPSM3";
import KWDispatchPSM3 from "../../../Macros/KWDispatchPSM3";
import { showSidebarMenu, setUser } from "../../../../actions/navActions";
import {
  setHasHeaderReceived,
  setUserArray,
} from "../../../../actions/headerActions";
import { connect } from "react-redux";
import ActiveEvents from "../ActiveEvents";
// [UPDATE] PP Operation event log, 250703
import ActiveEventsTable from "../ActiveEventsTable";

import { useHistory, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setCurrentPLC } from "../../../../actions/headerActions";
import RequestAccessModal from "../../../RequestAccess/RequestAccessModal";
import { isAuthorized, OPERATIONS_WRITE } from "../../../../lib/authorization";

// update 230711

const PPOperations_PSM3 = ({ hasHeaderReceived }) => {
  const [tags, settags] = React.useState([]);
  const [data, setData] = React.useState([]);
  const [overrideVisible, setOverrideVisible] = React.useState({
    visible: true,
  });
  const [isOperationModeCopied, setIsOperationModeCopied] =
    React.useState(false);
  // [UPDATE] PP Operation event log, 250703
  const [tableData, setTableData] = React.useState([]);
  let history = useHistory();
  const location = useLocation();
  const currentPLC = useSelector((state) => state.header.currentPLC);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.nav.user);
  const userCopy = useSelector((state) => state.nav.userCopy);
  const electronApp = useSelector((state) => state.nav.electronApp);
  const [userArr, setUserArr] = React.useState(null);
  const [requestor, setRequestor] = React.useState(null);
  const [pop, setPop] = React.useState(false);

  // [UPDATE] PP Operation event log, 250703
  React.useEffect(() => {
    fetchEvents();
    return () => {
      socket.removeAllListeners();
    };
  }, []);

  // [UPDATE] PP Operation event log, 250703
  const fetchEvents = () => {
    var eventdata = { buttonClickType: "Get Active Events" };
    socket.emit("button click", eventdata);
    socket.on("receive active events", (data) => {
      setTableData(data.result);
    });
  };

  React.useEffect(() => {
    dispatch(setCurrentPLC(location.pathname.slice(-4)));
  }, []);

  React.useEffect(() => {
    if (tags.length === 0 && hasHeaderReceived) {
      socket.emit("get tag names", [
        { display_id: 129 },
        { display_id: 256 },
        { display_id: 258 },
        { display_id: 257 },
      ]);
      socket.on("receive tag names", (data) => {
        settags(data.tags_data);
      });
    }
    return () => {
      socket.removeAllListeners();
    };
  }, [tags, hasHeaderReceived]);

  const ids = tags.map((t) => t.id);
  const FooterTags = tags.flatMap((t) =>
    // t.page_name === 'Footer_PSM3' ? [t] : []);
    t.display_id === 129 ? [t] : [],
  );

  const GenTags = tags.flatMap((t) =>
    // t.page_name === 'Power Plant Operations' ? [t] : []);
    t.display_id === 256 ? [t] : [],
  );

  const PPTags = GroupTemplate(GenTags, "tag_display_subgroup");

  const ShowSD = (value) => {
    if (value === 1) {
      return 1;
    } else {
      return 0;
    }
  };

  React.useEffect(() => {
    if (!electronApp) {
      var currentClient = `${user.name}:${socket.id}:${userCopy.hmi_role}`;
      socket.on("userDict", (response) => {
        let res = response[currentPLC];

        if (res.indexOf(currentClient) === 1) {
          if (userCopy.hmi_role !== user.hmi_role) {
            user.hmi_role = userCopy.hmi_role;
            dispatch(setUser(user));
          }
        } else {
          dispatch(setUserArray(response));

          for (var i = 2; i < res.length; i++) {
            var info = res[i].split(":");
            if (user.name === info[0]) {
              user.hmi_role = "E";
              setUser(user);
            }
          }
        }
      });
      socket.on("permission", (data) => {
        setUserArr(data.mainArr); // local variable
        setRequestor(data.requestor);
        setPop(true);
      });
      socket.on("access granted", (response) => {
        let data = response[currentPLC];
        if (data.indexOf(currentClient) === 1) {
          user.hmi_role = userCopy.hmi_role;
          dispatch(setUser(user));
        } else {
          dispatch(setUserArray(response));
          user.hmi_role = "E";
          dispatch(setUser(user));
        }
      });
      socket.on("access denied", () => {
        alert("ACCESS DENIED");
      });
      socket.on("access transferred", (data) => {
        alert(
          `Access has been tranferred to ${data.requested.split(":")[0]}. Comment: ${data.comment}`,
        );
      });
    }
    if (ids.length > 0) {
      socket.emit("get tag values", ids);
      socket.on("receive tag values", (value) => {
        setData(value.result);
      });

      return () => {
        socket.removeAllListeners();
      };
    }
  }, [ids, data]);

  React.useEffect(() => {
    let interval = setInterval(setOverrideVisiblity, 1000);
    return () => clearInterval(interval);
  }, [overrideVisible]); // eslint-disable-line react-hooks/exhaustive-deps

  const setOverrideVisiblity = () => {
    setOverrideVisible({
      ...overrideVisible,
      ["visible"]: !overrideVisible.visible,
    });
  };

  const parentcallback = useCallback((flag) => {
    if (flag === true) {
      setIsOperationModeCopied(false);
    }
  }, []);

  const PState = data[14545];
  const RState = data[14546];
  const IState = data[14553];
  const NState = data[14550];
  const OperIn_Idle = data[17425];
  const OperIn_GrInd = data[17427];
  const OperIn_GrConn = data[17426];
  const PPSD = data[17402];
  // const ExternalPower = data[39129]; // TODO : 250108, OPERIN_EXTERNALPOWER tags 매핑 필요
  const PPStart = data[33408]; // subPLC : DINBSTART_MODBUS 값 매핑

  // const N205Hung = data[9999];
  // const HTR302SDLatch = data[9999];
  // const LPGSelect = data[9999];

  const SDColumn = _.times(1, (i) =>
    Object.keys(PPTags[0]).map((i) =>
      PPTags[0][i].map((r) =>
        PPTags[0][i][0].tag_display_subgroup === "SD TYPE" ? (
          <Grid.Column>
            {r.tag_display_name === "NORMALSD" ? (
              <Grid.Column
                width="4"
                style={{
                  opacity: ShowSD(data[r.id]) ? "1" : "0.2",
                  overflowWrap: "break-word",
                  fontSize: "20px",
                  fontWeight: "bold",
                  color: "yellow",
                }}
              >
                {r.tag_display_name}{" "}
              </Grid.Column>
            ) : (
              <Grid.Column
                width="4"
                style={{
                  opacity: ShowSD(data[r.id]) ? "1" : "0.2",
                  fontSize: "20px",
                  fontWeight: "bold",
                  color: "yellow",
                }}
              >
                {r.tag_display_name}{" "}
              </Grid.Column>
            )}
          </Grid.Column>
        ) : (
          <></>
        ),
      ),
    ),
  );

  // update SOFC : 여기 아래부터는 수정아직안함
  const GetILTag = (id, value) => {
    const PPStart = data[33408];
    // ! TODO : TE110FT, TE120FT, TE300FT, TE090FT, IDC1, IDC2, IDC3 조건 미적용
    if (PPStart === 1) {
      if (value === 1 && id === 33246) return "CV020_STATUS = 0 ";
      else if ((value === 0 ) && id === 40114 ) return 'FS170_STATUS = 1';
      else if ((value < 0.0 || value > 3.0) && id === 14643)
        return "0.0 < FT012 < 3.0";
      //PDT020
      else if ((value < 0.0 || value > 5.0) && id === 32171)
        return "0.0 < PDT020 < 5.0";
      //PT410
      else if ((value < 0.0 || value > 10.0) && id === 32192)
        return "0.0 < PT410 < 10.0";
      //PDT380 -> range ?
      else if ((value < 0.0 || value > 5.0) && id === 32178)
        return "0.0 < PDT380 < 5.0";
      //PT720
      else if ((value < 0.0 || value > 10.0) && id === 32206)
        return "0.0 < PT720 < 10.0";
      else if ((value < -30 || value > 250) && id === 15488)
        return "-270 < TE380 < 2000";
      else if ((value < -30 || value > 250) && id === 15600)
        return "-270 < TE385 < 2000";
      else if ((value < -270 || value > 2000) && id === 17274)
        return "-270 < TE110FT < 2000";
      else if ((value < -270 || value > 2000) && id === 17267)
        return "-270 < TE120FT < 2000";
      else if ((value < -270 || value > 2000) && id === 17270)
        return "-270 < TE300FT < 2000";
      else if ((value < -270 || value > 2000) && id === 17273)
        return "-270 < TE090FT < 2000";
      // IDC1 조건 ?
      else if ((value < -999 || value > 999) && id === 17228)
        return "-999 < IDC_1 < 999";
      else if ((value < -999 || value > 999) && id === 17229)
        return "-999 < IDC_2 < 999";
      else if ((value < -999 || value > 999) && id === 17230)
        return "-999 < IDC_3 < 999";
    }
  };

  // 여기도 수정 안함
  const ILColumn = _.times(1, (i) =>
    Object.keys(PPTags[0]).map((i) =>
      PPTags[0][i].map((r) =>
        PPTags[0][i][0].tag_display_subgroup ===
        "P100 UNSATISFIED INTERLOCKS" ? (
          <Grid.Column
            key={r.id}
            width="4"
            style={{ textAlign: "center", marginBottom: "10px" }}
          >
            {GetILTag(r.id, data[r.id])}{" "}
          </Grid.Column>
        ) : (
          <></>
        ),
      ),
    ),
  );

  const MDColumn = _.times(1, (i) =>
    Object.keys(PPTags[0]).map((i) =>
      PPTags[0][i].map((r) =>
        PPTags[0][i][0].tag_display_subgroup === "MAJOR DATA" ? (
          <>
            <Grid.Column>{r.tag_display_name} </Grid.Column>
            <Grid.Column style={{ color: "yellow" }}>
              {data[r.id]} {r.unit}{" "}
            </Grid.Column>
          </>
        ) : (
          <></>
        ),
      ),
    ),
  );

  const PPStatus = (PS, RS, IS, OpIdle, OpGrInd, OpGrCon) => {
    // if((PS === 150 && IS === 26) || (PS === 160)) {
    //     return 'IDLE';
    // }
    if ((PS >= 5 && PS <= 100) || (PS >= 600 && PS <= 700)) {
      return "SHUTDOWN";
    } else if (PS >= 110 && PS <= 310 && RS !== 245 && OpIdle === 1) {
      return "STARTING - IDLE";
    } else if (PS >= 110 && PS <= 310 && RS !== 245 && OpGrInd === 1) {
      return "STARTING - GI LOAD";
    } else if (PS >= 110 && PS <= 310 && RS !== 245) {
      return "STARTING - GC LOAD";
    } else if (PS >= 110 && PS <= 285 && RS === 245) {
      return "BURNER LIGHT RETRY";
    } else if (PS === 320 && IS === 80) {
      return "LOAD(G/I)";
    } else if (PS === 320 && IS === 400) {
      // update SOFC 240417 by sumin, IS === 50 -> 400
      return "LOAD(G/C)";
    }
  };

  const prestartClick = (event) => {
    history.push("/PreStartChecks_PSM3");
  };

  const handleYes = () => {
    socket.emit("grant access", {
      message: "YES",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };
  const handleNo = () => {
    socket.emit("grant access", {
      message: "NO",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };

  // update SOFC : 아래에서부터 N205Hung 제거
  // update SOFC : 231020 [11726 : OPERIN_EXTERNALPOWER, 32899 : OPERIN_IDLE]
  // [UPDATE] PP Operation event log, 250703
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        flex: "1 1 auto",
        width:
          PState <= 101 || PState === 600 || (PState === 100 && PPStart === 1)
            ? "85%"
            : "90%",
      }}
    >
      {!electronApp && pop && (
        <RequestAccessModal
          pop={pop}
          yes={handleYes}
          no={handleNo}
          reqq={requestor.split(":")[0]}
        />
      )}
      <h1 style={styles.header}>POWERPLANT OPERATIONS : PSM3</h1>
      <Grid columns="equal">
        {/* <Grid.Column width={(PState <= 101 || PState === 600 || (PState === 100  && PPStart === 1)) ? '10' : null} style ={{marginRight: '50px'}}> */}
        <Grid.Column width="10" style={{ marginRight: "10px" }}>
          {" "}
          {/** [UPDATE] PP Operation event log, 250703 */}
          <Grid.Row>
            <h3>POWER PLANT STATUS</h3>
            <Grid style={styles.grid} inverted celled columns="equal">
              <Grid.Row>
                <Grid.Column style={{ color: "yellow" }}>
                  {PPStatus(
                    PState,
                    RState,
                    IState,
                    OperIn_Idle,
                    OperIn_GrInd,
                    OperIn_GrConn,
                  )}
                </Grid.Column>
                <Grid.Column>
                  {/*{ExternalPower === 1 ?*/}
                  {/*    <p style={{color: 'yellow'}}> EXTERNAL-HARDWARE CONTROL</p>*/}
                  {/*    :*/}
                  {/*    <p style={{color: 'red'}}> LOCAL-OPERATOR CONTROL</p>*/}
                  {/*}*/}
                  <p style={{ color: "red" }}> LOCAL-OPERATOR CONTROL</p>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Row>
          <Grid.Row>
            <h3> MAJOR DATA </h3>
            <Grid style={styles.grid} inverted celled columns="8">
              <Grid.Row>{MDColumn}</Grid.Row>
            </Grid>
          </Grid.Row>
          <Grid.Row style={{ marginTop: "10px" }}>
            {PPStart === 1 ? (
              overrideVisible.visible ? (
                <h1 style={{ color: "yellow" }}>POWER PLANT STARTING UP....</h1>
              ) : (
                <h1 style={{ color: "green" }}>POWER PLANT STARTING UP....</h1>
              )
            ) : (
              ""
            )}
          </Grid.Row>
          <Grid.Row style={{ marginTop: "10px" }}>
            <Grid columns="equal">
              <Grid.Column width={5}>
                <Segment inverted color="black">
                  {/*<Button.Group >*/}
                  {(electronApp ||
                    isAuthorized(user.hmi_role, OPERATIONS_WRITE)) && (
                    <Segment.Group horizontal>
                      <Segment
                        inverted
                        color="black"
                        style={{ textAlign: "center" }}
                      >
                        {PState === 110 ? (
                          <></>
                        ) : PState <= 101 || PState === 600 ? (
                          <PPOperationMacroPSM3
                            option={1}
                            data={data}
                            // HP ={HPEn}
                            title={"PSM3 Start PP"}
                            channel={"PSM3 Start PP"}
                            description={
                              "Verify N2 Pressure and Verify that the Back-up Shutdown Controller" +
                              "Circuit Breaker is ON"
                            }
                            isOperationModeCopied={isOperationModeCopied}
                            setIsOperationModeCopied={setIsOperationModeCopied}
                            parentcallback={parentcallback}
                          />
                        ) : PState === 500 ? (
                          <ConfirmMacro option={2} channel={"PSM3 Start PP"} />
                        ) : (
                          <PPOperationMacroPSM3
                            option={2}
                            title={"PSM3 Start PP"}
                            channel={"PSM3 Start PP"}
                            description={
                              "Cannot start or re-start powerplant from this P state"
                            }
                          />
                        )}
                      </Segment>
                      <Segment
                        inverted
                        color="black"
                        style={{ textAlign: "center" }}
                      >
                        {(PState === 450 || PState === 500) && PPSD === 1 ? (
                          <ConfirmMacro
                            option={2}
                            channel={"PSM3 Abort Plant Shutdown"}
                          />
                        ) : (
                          <ConfirmMacro
                            option={2}
                            channel={"PSM3 Plant Shutdown"}
                          />
                        )}
                      </Segment>
                    </Segment.Group>
                  )}
                  {(electronApp ||
                    isAuthorized(user.hmi_role, OPERATIONS_WRITE)) && (
                    <Segment.Group horizontal>
                      {/* <Segment inverted color='black' style={{textAlign: 'center'}}>
                                            <ConfirmMacro
                                                option ={2}
                                                channel ={'PSM3 Power Reset'} />
                                        </Segment> */}
                      <Segment
                        inverted
                        color="black"
                        style={{ textAlign: "center" }}
                      >
                        <ConfirmMacro
                          option={2}
                          channel={"PSM3 Burner Relight"}
                        />
                      </Segment>
                    </Segment.Group>
                  )}
                  {(electronApp ||
                    isAuthorized(user.hmi_role, OPERATIONS_WRITE)) && (
                    <Segment.Group horizontal>
                      <Segment inverted color="black" style={styles.retainBtn}>
                        <ConfirmMacro option={2} channel={"PSM3 Retain Save"} />
                      </Segment>
                      <Segment inverted color="black" style={styles.retainBtn}>
                        <ConfirmMacro option={2} channel={"PSM3 Retain Load"} />
                      </Segment>
                      {/** // [UPDATE] FR1.7 add button */}
                      <Segment inverted color="black" style={styles.retainBtn}>
                        <ConfirmMacro option={2} channel={"PSM3 Retain INIT"} />
                      </Segment>
                    </Segment.Group>
                  )}
                </Segment>
              </Grid.Column>
              <Grid.Column width={11}>
                <Segment inverted color="black">
                  <Grid inverted celled columns="7">
                    <Grid.Row stretched>
                      <Grid.Column width={5}>
                        <h3 style={{ marginRight: "10px" }}> S/D TYPE </h3>
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      {/*<h1 style ={{marginRight: '10px'}}> S/D TYPE </h1>*/}
                      {SDColumn}
                      {/** // [BUGFIX] 251002 Temporarily remove Clear XSD functionality */}
                      {/* { PState === 500 ?
                                                <PPOperationMacroPSM3
                                                    title ={'PSM3 Clear SD'}
                                                    channel = {'PSM3 Clear SD OK Button - Clear XSD'}
                                                    description = {'PSM3 Clear XSD while in P160 (PAFC)'}
                                                />
                                                : */}
                      {(electronApp ||
                        isAuthorized(user.hmi_role, OPERATIONS_WRITE)) && (
                        <PPOperationMacroPSM3
                          title={"PSM3 Clear SD"}
                          channel={
                            "PSM3 Clear SD OK Button - Clear Latched Shutdowns"
                          }
                          description={"PSM3 Clear latched shutdowns"}
                        />
                      )}
                      {/* }  */}
                    </Grid.Row>
                  </Grid>
                  <Grid inverted celled columns="3">
                    <Grid.Row>
                      {/*<h1 style ={{marginRight: '10px'}}> S/D TYPE </h1>*/}
                      <Grid.Column width={6} style={{ textAlign: "center" }}>
                        <h3 style={{ paddingTop: "5px" }}>TOTAL ALARMS </h3>
                      </Grid.Column>
                      <Grid.Column width={3} style={{ textAlign: "center" }}>
                        <h3 style={{ paddingTop: "5px" }}>{data[14561]}</h3>
                      </Grid.Column>
                      <Grid.Column width={6} style={{ textAlign: "center" }}>
                        {(electronApp ||
                          isAuthorized(user.hmi_role, OPERATIONS_WRITE)) && (
                          <ConfirmMacro
                            option={2}
                            channel={"PSM3 Clear Alarms"}
                          />
                        )}
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Segment>
              </Grid.Column>
            </Grid>
          </Grid.Row>
          <Grid.Row style={{ marginTop: "10px" }}>
            {/*// update SOFC 240403 by sumin, sent currentPLC data to EventLog to display each event*/}
            <Grid
              columns="equal"
              style={{ marginTop: "0px", paddingTop: "0px" }}
            >
              <Grid.Row>
                <Grid.Column width={5}>
                  <Grid inverted celled>
                    <Grid.Row>
                      <Grid.Column width={10} style={{ textAlign: "center" }}>
                        <ActiveEvents currentPLC={currentPLC} />
                      </Grid.Column>
                      <Grid.Column width={6} style={{ textAlign: "center" }}>
                        <EventLog
                          totalAlarms={data[14561]}
                          currentPLC={currentPLC}
                        />
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Grid.Column>
                {(electronApp ||
                  isAuthorized(user.hmi_role, OPERATIONS_WRITE)) && (
                  <Grid.Column width={7} style={{ marginLeft: "14px" }}>
                    <Grid inverted celled>
                      <Grid.Row>
                        <Grid.Column width={6} style={{ textAlign: "center" }}>
                          <OperationModePSM3
                            option={1}
                            data={data}
                            channel={"Operation Mode OK Button"}
                            tagid={17425}
                            isOperationModeCopied={isOperationModeCopied}
                            setIsOperationModeCopied={setIsOperationModeCopied}
                            parentcallback={parentcallback}
                          />
                        </Grid.Column>
                        <Grid.Column width={5} style={{ textAlign: "center" }}>
                          <KWDispatchPSM3
                            data={data}
                            channel={"KW Dispatch OK Button"}
                          />
                        </Grid.Column>
                        <Grid.Column width={5} style={{ textAlign: "center" }}>
                          <OperationModePSM3
                            option={2}
                            data={data}
                            tagid={39129}
                            isOperationModeCopied={isOperationModeCopied}
                            setIsOperationModeCopied={setIsOperationModeCopied}
                            parentcallback={parentcallback}
                          />
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </Grid.Column>
                )}
              </Grid.Row>
            </Grid>
          </Grid.Row>
        </Grid.Column>

        {PState <= 101 ||
        PState === 600 ||
        (PState === 100 && PPStart === 1) ? (
          <Grid.Column>
            <Grid.Row>
              {PState <= 101 || PState === 600 ? (
                <Button
                  color="blue"
                  content="PRE-START IO CHECKS"
                  onClick={(event, value) => prestartClick(event)}
                />
              ) : (
                ""
              )}
            </Grid.Row>
            {/* <Grid.Row>
                        <h1 style = {{visibility: N205Hung === 1 ?  'visible' : 'hidden', color: 'red'}}> N205 HUNGSTATE - FOLLOW FCSB87167</h1>
                    </Grid.Row> */}
            {/* <Grid.Row>
                        <h1 style = {{visibility: ((HTR302SDLatch === 1) && (LPGSelect === 1 ||LPGSelect === 2)) ?  'visible' : 'hidden', color: 'red'}}>
                            HTR302 SP lowered to 350 C. HTR302_SD_Timer reset required before PPLT startup </h1>
                    </Grid.Row> */}
            <Grid.Row
              style={{
                minHeight: 40,
                width: "95%",
                borderColor: "red",
                borderWidth: 1,
              }}
            >
              {PState === 100 && PPStart === 1 ? (
                <>
                  {overrideVisible.visible ? (
                    <h3 style={{ color: "yellow", textAlign: "center" }}>
                      P100 UNSATISFIED INTERLOCKS
                    </h3>
                  ) : (
                    <h3 style={{ color: "green", textAlign: "center" }}>
                      P100 UNSATISFIED INTERLOCKS
                    </h3>
                  )}
                  <p style={{ textAlign: "center" }}>
                    If Empty all sensor based interlocks are satisfied
                  </p>
                  {ILColumn}
                </>
              ) : (
                <></>
              )}
            </Grid.Row>
            <Grid.Row>
              {/** // [UPDATE] PP Operation event log, 250703 */}
              <ActiveEventsTable
                currentPLC={currentPLC}
                data={data}
                tableData={tableData}
                setTableData={setTableData}
                fetchEvents={fetchEvents}
              />
            </Grid.Row>
          </Grid.Column>
        ) : (
          <Grid.Column>
            <Grid.Row>
              {/** // [UPDATE] PP Operation event log, 250703 */}
              <ActiveEventsTable
                currentPLC={currentPLC}
                data={data}
                tableData={tableData}
                setTableData={setTableData}
                fetchEvents={fetchEvents}
              />
            </Grid.Row>
          </Grid.Column>
        )}
      </Grid>
      <div>
        <Footer tags={FooterTags} data={data} />
      </div>
    </div>
  );
};

const styles = {
  div: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: "1 1 auto",
    width: "100%",
  },
  header: {
    marginBottom: "5px",
    textAlign: "center",
  },
  footer: {
    position: "fixed",
    bottom: 0,
    left: 0,
  },
  grid: {
    marginTop: "10px",
  },
  left: {
    marginLeft: "20px",
  },
  right: {
    marginRight: "20px",
  },
  name: {
    whiteSpace: "pre-wrap",
  },
  Splname: {
    whiteSpace: "pre-wrap",
    overflowWrap: "break-word",
  },
  retainBtn: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
};

const mapDispatchToProps = (dispatch) => {
  return {
    showSidebar: () => dispatch(showSidebarMenu()),
    setHasHeaderReceived: (hasHeaderReceived) =>
      dispatch(setHasHeaderReceived(hasHeaderReceived)),
  };
};

const mapStateToProps = (state) => {
  return {
    sidebarVisible: state.nav.sidebarMenuVisible,
    hasHeaderReceived: state.header.hasHeaderReceived,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PPOperations_PSM3);
